import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading = signal<number>(0);

  get isLoading() {
    return this._loading() > 0;
  }

  setLoading(loading: boolean): void {
    if (loading) {
      this._loading.update(v => v + 1);
    } else {
      this._loading.update(v => Math.max(0, v - 1));
    }
  }
}
